import { url } from "./MongoConstants";

const getTeams = async () => {
    try {
        const server = url;
        const response = await fetch(server + '/api/data/teams', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return(data)
        } else {
            console.log('Failed to get teams');
            return('Failed to get teams');
        }
    } catch (error) {
        console.error('An error occurred:', error);
        return('An error occurred:', error);
    }
};

export default getTeams;